import { Stack } from '../../../Stack';
import { TableEmptyStateContainer, TableEmptyStatePrimaryText, TableEmptyStateSecondaryText } from './style';

interface TableEmptyStateProps {
    emptyStatePrimaryText: React.ReactNode;
    emptyStateSecondaryText: React.ReactNode;
    emptyStateAction?: React.ReactNode;
}

const TableEmptyState = ({
    emptyStatePrimaryText,
    emptyStateSecondaryText,
    emptyStateAction,
}: TableEmptyStateProps) => (
    <TableEmptyStateContainer>
        {/* We are temporarily using the illustration inline while we decide how to store and serve illustrations */}
        <Stack vertical spacing="100" itemAlignment="center" alignment="center">
            <svg width="81" height="80" viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.7124 26.9997H56.997V25.5C56.997 24.9477 56.5493 24.5 55.997 24.5H36.6629C34.4475 24.5 32.3629 23.4513 31.0424 21.6724L27.5025 16.9039C27.3138 16.6498 27.016 16.5 26.6995 16.5H18.002C17.4497 16.5 17.002 16.9477 17.002 17.5V41.875L21.7124 26.9997Z"
                    fill="url(#paint0_linear_561_40234)"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.7124 26.9997H56.997V25.5C56.997 24.9477 56.5493 24.5 55.997 24.5H36.6629C34.4475 24.5 32.3629 23.4513 31.0424 21.6724L27.5025 16.9039C27.3138 16.6498 27.016 16.5 26.6995 16.5H18.002C17.4497 16.5 17.002 16.9477 17.002 17.5V41.875L21.7124 26.9997Z"
                    fill="url(#paint1_linear_561_40234)"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M23.3039 30.0715L17.6462 53.2474L60.0287 53.2349L66.0465 30.0649L23.3039 30.0715Z"
                    fill="url(#paint2_linear_561_40234)"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M23.3039 30.0715L17.6462 53.2474L60.0287 53.2349L66.0465 30.0649L23.3039 30.0715Z"
                    fill="url(#paint3_linear_561_40234)"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M48.9841 55.9409C48.9841 51.7988 52.342 48.4409 56.4841 48.4409C60.6263 48.4409 63.9841 51.7988 63.9841 55.9409C63.9841 60.0831 60.6263 63.4409 56.4841 63.4409C52.342 63.4409 48.9841 60.0831 48.9841 55.9409ZM56.4841 45.4409C50.6851 45.4409 45.9841 50.1419 45.9841 55.9409C45.9841 61.7399 50.6851 66.4409 56.4841 66.4409C58.8316 66.4409 60.9991 65.6706 62.7476 64.369L67.9393 69.5607C68.5251 70.1464 69.4749 70.1464 70.0607 69.5607C70.6464 68.9749 70.6464 68.0251 70.0607 67.4393L64.8752 62.2539C66.1992 60.4968 66.9841 58.3105 66.9841 55.9409C66.9841 50.1419 62.2831 45.4409 56.4841 45.4409Z"
                    fill="#FF5A65"
                />
                <path
                    d="M61.995 26.6158V21.5C61.995 20.3954 61.0996 19.5 59.995 19.5H36.661C36.028 19.5 35.4324 19.2004 35.0551 18.6921L30.3158 12.3079C29.9385 11.7996 29.3429 11.5 28.7099 11.5H14C12.8954 11.5 12 12.3954 12 13.5V54C12 55.1046 12.8954 56 14 56H21.499"
                    stroke="#242435"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M27.7629 55.9961L16.6912 55.9978C15.3945 55.998 14.4404 54.7832 14.7479 53.5235L20.7719 28.8474C20.9905 27.9519 21.7927 27.3218 22.7145 27.3217L67.0012 27.3149C68.2979 27.3147 69.2519 28.5295 68.9444 29.7892L67.4385 35.9583L66.6855 39.0428"
                    stroke="#242435"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M65.4519 44.0534L67.3316 36.4281"
                    stroke="url(#paint4_linear_561_40234)"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M41.0536 55.9946L25.9819 55.9963"
                    stroke="url(#paint5_linear_561_40234)"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear_561_40234"
                        x1="25.1673"
                        y1="15.9129"
                        x2="38.8686"
                        y2="41.075"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#EFEFFF" />
                        <stop offset="1" stopColor="#EFEFFF" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient
                        id="paint1_linear_561_40234"
                        x1="25.5053"
                        y1="17.0793"
                        x2="41.7129"
                        y2="42.1314"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#D6E2FC" />
                        <stop offset="1" stopColor="#EFEFFF" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient
                        id="paint2_linear_561_40234"
                        x1="24.1505"
                        y1="23.7741"
                        x2="41.5252"
                        y2="59.1987"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#EFEFFF" />
                        <stop offset="1" stopColor="#EFEFFF" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient
                        id="paint3_linear_561_40234"
                        x1="24.656"
                        y1="25.3453"
                        x2="45.4815"
                        y2="61.0827"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#D6E2FC" />
                        <stop offset="1" stopColor="#EFEFFF" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient
                        id="paint4_linear_561_40234"
                        x1="66.334"
                        y1="40.5577"
                        x2="64.9911"
                        y2="45.6352"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#242435" />
                        <stop offset="1" stopColor="#242435" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient
                        id="paint5_linear_561_40234"
                        x1="35.5178"
                        y1="55.9946"
                        x2="42.5859"
                        y2="55.9946"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#242435" />
                        <stop offset="1" stopColor="#242435" stopOpacity="0" />
                    </linearGradient>
                </defs>
            </svg>
            <Stack vertical spacing="200" itemAlignment="center">
                <TableEmptyStatePrimaryText>{emptyStatePrimaryText}</TableEmptyStatePrimaryText>
                <TableEmptyStateSecondaryText>{emptyStateSecondaryText}</TableEmptyStateSecondaryText>
                {emptyStateAction}
            </Stack>
        </Stack>
    </TableEmptyStateContainer>
);

export { TableEmptyStateContainer };

export default TableEmptyState;
